import { Controller, useFormContext, Control } from 'react-hook-form';
import { CustomFileInput, ICustomFileInput } from './Custom/CustomFileInput';

interface IFormInputFile extends ICustomFileInput {
  control?: Control<any>;
  [x: string]: any;
}

export const FormInputFile = (props: IFormInputFile) => {
  const { control, ...restProps } = props;
  const methods = useFormContext();
  const _control = methods?.control || control;

  return _control ? (
    <Controller
      control={_control}
      name={restProps?.name}
      render={(renderProps) => {
        const {
          field,
          fieldState: { error },
        } = renderProps;
        const { ref, ...restFieldProps } = field;

        return <CustomFileInput {...restProps} {...restFieldProps} error={error} />;
      }}
    />
  ) : (
    <CustomFileInput {...restProps} />
  );
};
